import { render, staticRenderFns } from "./SettingsTabs.vue?vue&type=template&id=407d3eab"
import script from "./SettingsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsTabs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports